import React from 'react';
import { Link } from 'react-router-dom';
import AZIENDA from '../config/azienda';
import { AvvisoLingua, BottoneRitorno, useApertura } from './PrivacyPolicy';
import { useTraduzioniOspite } from '../utils/linguaOspite';

// In cima, con il titolo della scheda e "Torna" alla pagina di provenienza: come la privacy (PrivacyPolicy.jsx).
// Anche qui il testo resta in italiano: tradotti solo il titolo, la data e l'avviso.
const TerminiServizio = () => {
  const { t } = useTraduzioniOspite();
  useApertura('MK Client — Termini');
  return (
    <div className="min-h-screen bg-background text-white">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <BottoneRitorno />

        <h1 className="text-4xl font-display font-bold text-gold mb-2 break-words">{t('legali.termini')}</h1>
        <p className="text-muted-foreground mb-8">{t('legali.aggiornato', { data: t('legali.data') })}</p>
        <AvvisoLingua />

        <div className="space-y-8 text-sm leading-relaxed text-white/80">
          
          <section>
            <h2 className="text-xl font-display text-gold mb-3">1. Descrizione del Servizio</h2>
            <p>
              MK Client è una piattaforma digitale di gestione immobiliare fornita da <strong className="text-white">MK Consulting</strong>. 
              Il servizio consente ai clienti di monitorare la propria pratica immobiliare, visualizzare gli immobili proposti, 
              gestire documenti, programmare visite e sincronizzare appuntamenti con il proprio calendario.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">2. Accettazione dei Termini</h2>
            <p>
              Registrandosi e utilizzando MK Client, l'utente accetta integralmente i presenti Termini di Servizio 
              e l'<Link to="/privacy" className="text-gold hover:underline">Informativa sulla Privacy</Link>. 
              In caso di disaccordo, l'utente è tenuto a non utilizzare il servizio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">3. Registrazione e Account</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>L'utente si impegna a fornire dati veritieri e aggiornati al momento della registrazione</li>
              <li>L'utente è responsabile della custodia delle proprie credenziali di accesso</li>
              <li>L'utente deve comunicare tempestivamente qualsiasi uso non autorizzato del proprio account</li>
              <li>MK Consulting si riserva il diritto di sospendere o eliminare account che violino i presenti termini</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">4. Utilizzo del Servizio</h2>
            <p className="mb-2">L'utente si impegna a:</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Utilizzare la piattaforma esclusivamente per finalità connesse alla consulenza immobiliare con MK Consulting</li>
              <li>Non tentare di accedere a dati di altri utenti o aree non autorizzate della piattaforma</li>
              <li>Non caricare contenuti illeciti, offensivi o che violino diritti di terzi</li>
              <li>Non utilizzare sistemi automatizzati per accedere al servizio senza autorizzazione</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">5. Integrazione Google Calendar</h2>
            <p>
              MK Client offre la possibilità di collegare il proprio account Google Calendar per la sincronizzazione 
              degli appuntamenti. Collegando l'account, l'utente autorizza MK Client a creare, leggere, modificare 
              ed eliminare eventi sul proprio calendario relativi alla pratica immobiliare. L'utente può revocare 
              tale autorizzazione in qualsiasi momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">6. Proprietà Intellettuale</h2>
            <p>
              Tutti i contenuti della piattaforma MK Client (software, design, testi, loghi) sono di proprietà 
              di MK Consulting e sono protetti dalle leggi sulla proprietà intellettuale. È vietata la riproduzione, 
              distribuzione o modifica dei contenuti senza autorizzazione scritta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">7. Limitazione di Responsabilità</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>MK Client è fornito "così com'è". MK Consulting non garantisce la disponibilità ininterrotta del servizio</li>
              <li>MK Consulting non è responsabile per perdite di dati dovute a cause di forza maggiore o malfunzionamenti tecnici</li>
              <li>Le informazioni immobiliari presenti sulla piattaforma hanno carattere informativo e non costituiscono offerta contrattuale</li>
              <li>MK Consulting non è responsabile per il contenuto di siti esterni raggiungibili tramite link presenti sulla piattaforma</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">8. Trattamento dei Dati Personali</h2>
            <p>
              Il trattamento dei dati personali è disciplinato dall'<Link to="/privacy" className="text-gold hover:underline">Informativa sulla Privacy</Link>, 
              parte integrante dei presenti Termini di Servizio. MK Consulting tratta i dati in conformità al 
              Regolamento (UE) 2016/679 (GDPR).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">9. Modifiche ai Termini</h2>
            <p>
              MK Consulting si riserva il diritto di modificare i presenti Termini di Servizio in qualsiasi momento. 
              Le modifiche saranno comunicate tramite la piattaforma. L'uso continuato del servizio dopo la 
              pubblicazione delle modifiche costituisce accettazione dei nuovi termini.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">10. Cancellazione dell'Account</h2>
            <p>
              L'utente può richiedere la cancellazione del proprio account e di tutti i dati associati 
              contattando MK Consulting all'indirizzo{' '}
              <a href="mailto:maksym@mkconsulting.it" className="text-gold hover:underline">maksym@mkconsulting.it</a>. 
              La cancellazione sarà effettuata entro 30 giorni dalla richiesta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">11. Legge Applicabile e Foro Competente</h2>
            <p>
              I presenti Termini di Servizio sono regolati dalla legge italiana. Per qualsiasi controversia 
              sarà competente il Foro del luogo di residenza del consumatore, ai sensi del Codice del Consumo.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display text-gold mb-3">12. Contatti</h2>
            <p>
              Per qualsiasi domanda relativa ai presenti Termini di Servizio:<br />
              <strong className="text-white">{AZIENDA.nome}</strong><br />
              {AZIENDA.via}, {AZIENDA.cap} {AZIENDA.citta} ({AZIENDA.provincia}) · P.IVA {AZIENDA.partitaIva}<br />
              Email: <a href="mailto:maksym@mkconsulting.it" className="text-gold hover:underline">maksym@mkconsulting.it</a><br />
              Sito web: <a href="https://mkconsulting.it" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">mkconsulting.it</a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TerminiServizio;
